const commonSliceKey = {
  all: ['COMMON'],
};

export default commonSliceKey;
